const state = {
  showFooter: false,
  current_id: null, //
  current_title: null, //
  current_duration: 0,
  current_index: null, //
  current_flag: false,
  current_url: "", //
  current_time: 0,
  click_num: 0,
  click_time: 0, //
  add_click: false,
};
const mutations = {
  //commit
  showFooter(state, bool) {
    state.showFooter = bool;
  },
  currentId(state, id) {
    state.current_id = id;
  },
  currentTitle(state, title) {
    state.current_title = title;
  },
  currentIndex(state, index) {
    state.current_index = index;
  },
  currentDuration(state, duration) {
    state.current_duration = duration;
  },
  currentFlag(state, flag) {
    state.current_flag = flag;
  },
  currentUrl(state, url) {
    state.current_url = url;
  },
  currentTime(state, time) {
    state.current_time = time;
  },
  currentClickNum(state, num) {
    state.click_num = num;
  },
  clickTime(state, time) {
    state.click_time = time;
  },
  addClick(state, addclick) {
    state.add_click = addclick;
  },
};
const actions = {
  //dispatch
  showFooter: ({ commit }) => commit("showFooter"),
  currentId: ({ commit }) => commit("currentId"),
  currentTitle: ({ commit }) => commit("currentTitle"),
  currentIndex: ({ commit }) => commit("currentIndex"),
  currentDuration: ({ commit }) => commit("currentDuration"),
  currentFlag: ({ commit }) => commit("currentFlag"),
  currentUrl: ({ commit }) => commit("currentUrl"),
  currentTime: ({ commit }) => commit("currentTime"),
  currentClickNum: ({ commit }) => commit("currentClickNum"),
  clickTime: ({ commit }) => commit("clickTime"),
  addClick: ({ commit }) => commit("addClick"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
